import React from "react";
import ReactDOM from "react-dom";

class Modal extends React.Component {
  componentDidMount() {
    document.querySelector("body").style.overflowY = "hidden";
    document.querySelector("html").style.overflowY = "hidden";

    document.querySelector("body").style.height = "100%";
    document.querySelector("html").style.height = "100%";
  }

  componentWillUnmount() {
    document.querySelector("body").style.overflowY = "auto";
    document.querySelector("html").style.overflowY = "auto";
    document.querySelector("body").style.height = "initial";
    document.querySelector("html").style.height = "initial";
  }
  render() {
    return ReactDOM.createPortal(
      <div className="modal__container">
        <div className="close__icon__container">
          <div className="filter__reset__button" onClick={() => this.props.reset()}>
            reset
          </div>
          <div className="close__icon" onClick={() => this.props.close()} />
        </div>
        {this.props.children}
      </div>,
      document.getElementById("modal-root")
    );
  }
}

export default Modal;
